import type EnType from '../en-US/component';

export default {
  'component.securityScheme.formItemName.authorizationType': 'Tipo de Autorización',
  'component.securityScheme.apiKeyFormItem.name.label': 'Nombre',
  'component.securityScheme.allowedSecuritySchemes': 'Esquema de Seguridad Permitido',
  'component.securityScheme.preview.title': 'Esquema de Seguridad',
  'component.securityScheme.optional': 'Hacer la Seguridad Opcional',
  'component.securityScheme.inheritFrom': 'Heredado de la carpeta padre',
  'component.securityScheme.noAuthDesc': 'No se requiere autenticación',
  'component.securityScheme.useCase.empty-alert':
    'El esquema de seguridad referenciado por este endpoint ha sido eliminado. Por favor modifica la configuración de autenticación de este endpoint.',
} satisfies typeof EnType;
